import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Auth } from '../../../../../autentication/Auth';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixQrCodeReturn } from '../../../models/qr-code-return.model';
import { PixQrCodeDynamicService } from '../qr-code-dynamic.service';
import { PixQrCodeDynamicModalDateComponent } from './modal-date/modal-date.component';
import { PixQrCodeDynamicModalMsgComponent } from './modal-msg/modal-msg.component';
import { PixQrCodeDynamicModalValueComponent } from './modal-value/modal-value.component';

@Component({
	selector: 'app-pix-qr-code-dynamic-resume-final',
	templateUrl: './resume-final.component.html',
	styleUrls: ['./resume-final.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixQrCodeDynamicResumeFinalComponent implements OnInit {
	public pixQrCodeReturn: PixQrCodeReturn;
	public meuNome: string;
	public meuCpfCnpj: string;

	constructor(
		private router: Router,
		private pixQrCodeDynamicService: PixQrCodeDynamicService,
		private dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.pixQrCodeReturn = this.pixQrCodeDynamicService.getSelectedPixQrCodeReturn();
		this.meuNome = Auth.getInstance().getUser().name;
		this.meuCpfCnpj = Auth.getInstance().getUser().cpf;
		this.invalidParams();
	}

	invalidParams(): void {
		if (this.pixQrCodeReturn === undefined || this.pixQrCodeReturn.valor === undefined || this.pixQrCodeReturn.chavePix === undefined) {
			this.goBack();
		}
	}


	editValue() {
		const dialogRef = this.dialog.open(PixQrCodeDynamicModalValueComponent, {
			width: '250px',
			data: {
				value: this.pixQrCodeReturn.valor
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.pixQrCodeReturn.valor = result;
			}
		});
	}

	editDate() {
		const dialogRef = this.dialog.open(PixQrCodeDynamicModalDateComponent, {
			width: '250px',
			data: {
				date: this.pixQrCodeReturn.qrCodeDinamico.calendario.dataCriacao,
				maxDate: this.pixQrCodeReturn.qrCodeDinamico.calendario.dataExpiracao
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.pixQrCodeReturn.qrCodeDinamico.calendario.dataCriacao = result;
			}
		});
	}

	editMsg() {
		const dialogRef = this.dialog.open(PixQrCodeDynamicModalMsgComponent, {
			width: '250px',
			data: {
				msg: this.pixQrCodeReturn.qrCodeDinamico.mensagem
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.pixQrCodeReturn.qrCodeDinamico.mensagem = result;
			}
		});
	}

	confirm() {
		this.router.navigate(['pix/pagamento/qrcode-dinamico/assinatura']);
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	goBack = () => this.router.navigate(['pix/pagamento/pix-copia-cola']);

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/copy-and-paste/qr-code-dynamic/resume-final/resume-final.component.ts